import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import html2pdf from "html2pdf.js";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

export const baseURL = process.env.REACT_APP_API_BASE_URL;

export const imageURL = baseURL + "uploads/";
export const apiUrl = baseURL + "api";

export const api = apiUrl;

export const saveRecords = async (payload, endpoint) => {
  try {
    // Fetch token from localStorage
    const response = await fetch(apiUrl + endpoint, {
      method: "POST", // Use POST method
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload), // Stringify the payload
    });
    return response.json();
  } catch (error) {
    console.error("fetahcData Error fetching data:", error);
    throw error; // Re-throw the error for further handling if needed
  }
};

export const getRecords = async (payload, endpoint) => {
  try {
    // Fetch token from localStorage
    const response = await fetch(apiUrl + endpoint, {
      method: "POST", // Use POST method
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload), // Stringify the payload
    });
    return response.json();
  } catch (error) {
    console.error("fetahcData Error fetching data:", error);
    throw error; // Re-throw the error for further handling if needed
  }
};

export const dropdownData = async (
  responseData,
  fieldName,
  selectedFieldName,
  isOtherDependentOnThis
) => {
  try {
    if (!responseData && responseData.length == 0) {
      return []; // Return empty array if no data is available
    }
    var options = [];
    responseData.forEach((element) => {
      options.push({
        label: element[fieldName],
        value: element.id,
        fieldName: selectedFieldName,
        isOtherDependentOnThis,
        data: responseData,
      });
    });
    const dropdownResponseData = [{ options: options }];
    return dropdownResponseData;
  } catch (error) {
    console.error("Error fetching data:", error);
    // Handle errors appropriately (throw error, display error message, etc.)
    throw error; // Re-throw the error for further handling if needed
  }
};

export const uploadFile = async (folderPath, file) => {
  try {
    // Create a FormData object to send data as 'multipart/form-data'
    const formData = new FormData();
    formData.append("folderPath", folderPath);
    formData.append("files", file);

    // Make the API call using fetch
    const response = await fetch(apiUrl + "/uploadBinaryFile", {
      method: "POST",
      body: formData,
    });

    // Check if the response is successful
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    // Parse and return the JSON response
    const data = await response.json();
    if (data?.data && data?.data[0]) {
      const filePath = baseURL + data?.data[0]?.filePath;
      const fileName = data?.data[0]?.fileName;
      return { filePath, fileName };
    }
    return data;
  } catch (error) {
    console.error("Error uploading file:", error);
    throw error; // Rethrow error for handling in the calling component
  }
};

export const exportToExcel = (exportData, fileName) => {
  if (!exportData || exportData.length === 0) {
    toast.error("No data available to export.");
    return;
  }
  console.log("exportData", exportData);

  try {
    // Modify the is_active field

    // Create a new workbook and worksheet with the modified data
    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Data");

    // Write the Excel file
    XLSX.writeFile(workbook, fileName);
    toast.success("Data exported successfully!");
  } catch (error) {
    console.error("Error exporting data:", error);
    toast.error("Failed to export data.");
  }
};

const DownloadExcel = async ({
  fileName,
  columns,
  data,
  cellColor = false,
}) => {
  const styleConfig = {
    borders: true,
    alignment: "center",
  };
  const mainHeading = fileName;
  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("Sheet1");

  if (data.length == 0) {
    toast.error("No Data Available!");
    return;
  }

  if (mainHeading) {
    const headingRow = sheet.addRow([
      mainHeading.replace(/([A-Z])/g, " $1").trim(),
    ]);
    sheet.mergeCells(`A1:${String.fromCharCode(64 + columns.length)}1`);
    headingRow.height = 25;

    headingRow.eachCell((cell) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "C6E0B4" },
      };
      cell.font = { bold: true, size: 14, color: { argb: "000000" } };
      cell.alignment = { horizontal: "center", vertical: "middle" };
    });
  }

  // Add header row in the second row
  const headerRow = sheet.addRow(columns.map((col) => col.label)); // Add header labels
  headerRow.eachCell((cell) => {
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "2F75B5" },
    };
    cell.font = { bold: true, color: { argb: "000000" } }; // Bold and black font
    cell.alignment = { horizontal: "center", vertical: "middle" }; // Center alignment

    if (styleConfig?.borders) {
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    }
  });
  columns.forEach((col, index) => {
    sheet.getColumn(index + 1).width = 25; // Set width for each column
  });

  // Add data rows starting from the third row
  data.forEach((row, index) => {
    // Map the row object to an array of values based on the columns
    const rowData = columns.map((col) => row[col.key]);

    // Add the row data to the sheet
    const newRow = sheet.addRow(rowData);

    // Apply styling to the row
    columns?.forEach((col, colIndex) => {
      const cell = newRow.getCell(colIndex + 1);
      if (cellColor) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: index % 2 === 0 ? "F2F2F2" : "FFFFFF" }, // Alternate row colors
        };
      }
      if (styleConfig?.bold?.includes(col.key)) {
        cell.font = { bold: true };
      }

      cell.alignment = { horizontal: styleConfig?.alignment };

      if (styleConfig?.borders) {
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      }
    });

    if (row.isHeader) {
      newRow.eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "9DC3E6" },
        };
        cell.font = { bold: true, color: { argb: "000000" } };
        cell.alignment = { horizontal: "center" };
      });
    }
    if (row.isHeader1) {
      newRow.eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "D6E3F3" },
        };
        cell.font = { bold: true, color: { argb: "000000" } };
        cell.alignment = { horizontal: "center" };
      });
    }
    if (row.isHeader2) {
      newRow.eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "EAF1FB" }, //
        };
        cell.font = { bold: true, color: { argb: "000000" } };
        cell.alignment = { horizontal: "center" };
      });
    }
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, `${fileName}.xlsx`);
};

export default DownloadExcel;

export const uploadExelFile = async (folderPath, file, endpoint) => {
  try {
    const formData = new FormData();
    formData.append("folderPath", folderPath);
    formData.append("file", file); // Assuming the backend expects 'files'

    // Sending POST request to backend
    const response = await fetch(apiUrl + endpoint, {
      method: "POST",
      body: formData,
    });
    console.log("response", response);
    if (!response.ok) {
      const data = await response.json();
      console.log("response", data);

      throw new Error(`Error: ${data.message}` || "Error in importing data");
    }

    // Handle successful response
    const data = await response.json();

    // Check if the response contains the expected data structure

    return data;
  } catch (error) {
    console.error("Error uploading file:", error);
    throw error;
  }
};

export const DownloadPDFData = (pdfName) => {
  const content = document.getElementById("pdfContent");

  if (!content) {
    console.error("PDF content not found");
    return;
  }

  const previousDisplay = content.style.display;
  const previousPosition = content.style.position;
  const previousLeft = content.style.left;

  content.style.display = "block";
  content.style.position = "relative";
  content.style.left = "0";

  // Avoid page breaks within elements
  const allChildren = content.querySelectorAll("*");
  allChildren.forEach((child) => {
    child.style.pageBreakInside = "avoid";
    child.style.breakInside = "avoid";
  });

  const spacer = document.createElement("div");
  spacer.style.height = "50px";
  content.appendChild(spacer);

  setTimeout(() => {
    const pdfOptions = {
      margin: [10, 10, 15, 10],
      filename: pdfName,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: {
        scale: 2,
        useCORS: true,
        scrollY: 0,
      },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    };

    html2pdf()
      .set(pdfOptions)
      .from(content)
      .toPdf()
      .get("pdf")
      .then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        const formattedDate = new Date().toLocaleString("en-US", {
          month: "numeric",
          day: "numeric",
          year: "numeric",
          hour: "numeric",
          minute: "numeric",
          hour12: true,
        });

        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);
          pdf.setFontSize(10);

          // ✅ Add page number and date in the footer
          pdf.text(
            `Page ${i} of ${totalPages}`,
            pageWidth - 40,
            pageHeight - 5
          );

          if (i === totalPages) {
            pdf.text(formattedDate, 10, pageHeight - 5);
          }
        }

        const pdfBlob = pdf.output("blob");
        const pdfURL = URL.createObjectURL(pdfBlob);

        window.open(pdfURL, "_blank");

        const link = document.createElement("a");
        link.href = pdfURL;
        link.download = pdfName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Cleanup styles and spacer
        content.removeChild(spacer);
        content.style.display = previousDisplay;
        content.style.position = previousPosition;
        content.style.left = previousLeft;
      });
  }, 10);
};

export const formatDate = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${year}-${month}-${day}`;
};

export const formatNumber = (value) => {
  if (value === null || value === undefined || value === "") return "0";
  const num = Number(value);
  if (isNaN(num)) return "0";
  const formatted = num.toFixed(2).toString();
  return formatted.replace(/\.00$/, "");
};
